module.exports = __webpack_public_path__ + "static/media/lightgrey_grid.34e387e5.svg";